import { getCurrentLanguage } from 'utils/getCurrentLanguage';
import i18n from 'locales/i18n';

export interface LanguageTypes {
  name: string;
  code: string;
}

type Lang = 'ar' | 'en' | string

const languages: LanguageTypes[] = [
  { name: 'عربي', code: 'ar' },
  { name: 'English', code: 'en' },
];

export const useLanguage = () => {
  const currentLanguageCode: Lang = getCurrentLanguage();
  const currentLanguageName = (languages.find(item => item.code === currentLanguageCode) as unknown as LanguageTypes).name;

  const changeLanguage = (lang: Lang) => {
    if (allowedLanguageCodes().find(lng => lng === lang)) {
      i18n.changeLanguage(lang);
      if(currentLanguageCode !== lang) {
        location.reload();
      }
    }
  };

  const allowedLanguageCodes = () => {
    return languages.map(lng => lng.code);
  };

  return {
    languages,
    changeLanguage,
    allowedLanguageCodes,
    currentLanguageCode,
    currentLanguageName,
  };
};